var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('plaid-link',_vm._b({scopedSlots:_vm._u([{key:"default",fn:function(ref){
var openPlaid = ref.openPlaid;
return _c('div',{},[_vm._t("default",null,{"isLinking":_vm.isLinking,"openPlaid":openPlaid})],2)}}],null,true)},'plaid-link',{onEvent: _vm.onEvent, onExit: _vm.onExit, onSuccess: _vm.onSuccess},false))}
var staticRenderFns = []

export { render, staticRenderFns }